// Auto-generated per-query builders for Invite
// DO NOT EDIT - Changes will be overwritten

import { QueryBuilderBase } from '@sourcepilot/framework/query-builder-base';
import { NeoNodeBase } from '@sourcepilot/framework/neo-node-base';
import { RelationshipManager } from '@sourcepilot/framework/relationship-manager';
import { Relationship } from '@sourcepilot/framework/relationship';
import { InviteReadAPI, InviteWriteAPI, InviteReadAPISchema, InviteWriteAPISchema } from '../types/invite';
import { ModelRegistry } from '../../registries/model-registry';
import { InviteTo } from '../../relationships/relationship';

import { SecurityScope } from '../../shared/api/securityscope';



// Field names for order_by on Invite
type InviteFields = "created_at" | "-created_at" | "email" | "-email";


// Include spec for query: BaseAllInvitesIncludeSpec
export interface BaseAllInvitesIncludeSpec {
  scope?: {
  };
}


// Builder chain for query: base-all-invites

export interface BaseAllInvitesBuilder_0 {
  orderBy(field?: InviteFields): BaseAllInvitesBuilder_0;
}

export interface BaseAllInvitesBuilder_0 {
  limit(value?: number): BaseAllInvitesBuilder_0;
  load(include: BaseAllInvitesIncludeSpec): BaseAllInvitesBuilder_0;
  all(): Promise<Invite[]>;
  first(): Promise<Invite | null>;
  get(): Promise<Invite[]>;
  execute(): Promise<Invite[]>;
}


// Union of all query entry points
export type InviteQueryBuilder = BaseAllInvitesBuilder_0;

// Available query names for .setQuery()
export type InviteQueryNames = "base-all-invites";

// Type narrowing for .setQuery()
export type InviteBuilderForQuery<Q extends InviteQueryNames> =
  Q extends "base-all-invites" ? BaseAllInvitesBuilder_0
  : never;

// Type for instance setQuery - returns post-filter/post-get builder
export type InviteInstanceQueryResult<Q extends InviteQueryNames> =
  Q extends "base-all-invites" ? BaseAllInvitesBuilder_0
  : never;

// Map path signatures to query names
const QUERY_PATH_MAP: Record<string, string> = {
  'order_by|limit': 'base-all-invites',
};

// Model-specific QueryBuilder implementation
class QueryBuilderImpl extends QueryBuilderBase {
  constructor(
    modelName: string,
    path: string[] = [],
    params: Record<string, any> = {},
    fetchFn?: (path: string, options?: RequestInit) => Promise<any>,
    queryName?: string,
    scopedParams: Record<string, Record<string, any>> = {}
  ) {
    super(modelName, path, params, fetchFn, queryName, scopedParams, QUERY_PATH_MAP, QueryBuilderImpl);
  }

  setQuery<Q extends InviteQueryNames>(queryName: Q): InviteBuilderForQuery<Q> {
    // Create new builder with queryName set to bypass path lookup
    return new QueryBuilderImpl(
      this.modelName,
      this.path,
      this.params,
      this.fetchFn,
      queryName,
      this.scopedParams
    ) as any;
  }
}


export interface Invite extends Partial<InviteReadAPI> {}
export class Invite extends NeoNodeBase<InviteReadAPI, InviteWriteAPI> {
  // Static label for identifying this model type (minification-safe)
  static readonly label = "Invite";
  static readonly readSchema = InviteReadAPISchema;
  static readonly writeSchema = InviteWriteAPISchema;

  // Per-relationship metadata, keyed by property name on this class.
  // See `framework/data/dag-sync/reverse-property.ts` for how the DAG
  // client uses (relClass, direction) to route patches back to the
  // correct property — especially for polymorphic-source rels.
  static readonly relationships: Record<string, {
    target: string;
    cardinality: 'one' | 'many';
    isParent: boolean;
    relClass: string;
    direction: 'in' | 'out';
  }> = {
    scope: { target: "SecurityScope", cardinality: "one", isParent: true, relClass: "InviteTo", direction: "out" },
  };

  protected get modelName(): string {
    return 'Invite';
  }

  // Instance getter for label (used in DAG sync and type identification)
  get _label(): string {
    return Invite.label;
  }


  constructor(data: Partial<InviteWriteAPI> = {}) {
    super(data);
  }

/**
   * Load instance from server data with Zod validation
   * Recursively instantiates nested relationship objects
   *
   * @param data - Node data from API (ReadAPI format)
   * @param loadContext - Optional LoadContext from backend QueryResult for eager-loaded relationships
   * @returns Class instance with nested relationships instantiated
   */
  static load(data: InviteReadAPI, loadContext?: Record<string, any>): Invite {
    // Import relationship loaders
    const { loadOneRelationship, loadManyRelationship } = require('@sourcepilot/framework/load-relationship');

    // Strip relationship fields before validation (they'll be processed separately)
    const { scope, _label, ...dataToValidate } = data as any;

    // Validate with Zod schema (only non-relationship fields)
    const validated = InviteReadAPISchema.parse(dataToValidate);

    // Re-add relationship fields to validated data for processing
    const dataWithRelationships: any = { ...validated, scope: scope };

    // If loadContext provided, use NeoGraphParser to reconstruct relationships
    if (loadContext && validated.id) {
      // Import NeoGraphParser dynamically to avoid circular dependencies
      const { NeoGraphParser } = require('@sourcepilot/framework/neograph-utils');
      const parser = new NeoGraphParser();
      const graphNodes = parser.parse([validated], loadContext);

      if (graphNodes.length > 0) {
        // Convert graph structure back to plain object with relationships
        const withRelationships = parser.toPlainObject(graphNodes[0]);
        // Recursively instantiate via ModelRegistry (without loadContext to avoid infinite loop)
        return Invite.load(withRelationships);
      }
    }

    // Recursively instantiate nested relationships from inline data
    const processed: any = { ...dataWithRelationships };

    // Process relationships: convert to class instances and store with private property names
    loadOneRelationship(processed, 'scope', 'SecurityScope', ModelRegistry);
    // Create instance with processed data (constructor uses Object.assign)
    // Private properties (_*) won't conflict with relationship getters
    const instance = new Invite(processed as any);

    return instance;
  }

  static filter(conditions: Record<string, any>): InviteQueryBuilder {
    return new QueryBuilderImpl('Invite').filter(conditions) as any;
  }

  static all(): InviteQueryBuilder {
    return new QueryBuilderImpl('Invite') as any;
  }

  static async first(): Promise<Invite | null> {
    const results = await new QueryBuilderImpl('Invite').execute();
    return results[0] || null;
  }


  static setQuery<Q extends InviteQueryNames>(queryName: Q): InviteBuilderForQuery<Q> {
    const builder = new QueryBuilderImpl('Invite');
    return builder.setQuery(queryName);
  }

  /**
   * Instance method to create queries pre-filtered by this instance's ID.
   * Enables queries like: thread.setQuery('thread-with-steps').steps.all()
   * Returns the same builder type as static method after applying ID filter.
   */
  setQuery<Q extends InviteQueryNames>(queryName: Q): InviteInstanceQueryResult<Q> {
    if (!this.id) {
      throw new Error('Cannot query an unsaved instance without an ID');
    }
    // Create a query builder and apply the ID
    const builder = Invite.setQuery(queryName) as any;

    // Try .get(id) first (if the query starts with Thread.get())
    // Otherwise use .filter({id}) (if the query starts with Thread.filter(id=...))
    // The return type mapping handles which builder stage is returned
    if (builder.get && typeof builder.get === 'function') {
      return builder.get(this.id);
    } else if (builder.filter && typeof builder.filter === 'function') {
      return builder.filter({ id: this.id });
    }
    return builder;
  }

  /**
   * Delete this instance from the server.
   *
   * @param options - Delete options
   * @param options.cascade - Whether to cascade delete related nodes (default: true for most models)
   * @param options.dryRun - If true, return what would be deleted without actually deleting
   * @returns DeleteResult with deleted IDs and count
   *
   * @example
   * ```typescript
   * const invite = await Invite.get(id).first();
   * await invite.delete();  // Delete with default cascade
   *
   * // Or with options
   * const result = await invite.delete({ cascade: false, dryRun: true });
   * console.log('Would delete:', result.deletedIds);
   * ```
   */
  async delete(options: {
    cascade?: boolean;
    dryRun?: boolean;
  } = {}): Promise<{ deletedIds: string[]; count: number }> {
    return this._deleteInstance(options);
  }

  // Relationship manager for 'scope' - Python ORM style (cached)
  get scope(): RelationshipManager<this, SecurityScope> {
    return this.getOrCreateRelationshipManager('scope', () => {
      return new RelationshipManager(this, 'scope', 'one', InviteTo as typeof Relationship);
    });
  }

}
